(function () {
  function init() {
    var root = document.querySelector('[data-partners]');
    if (!root) return;

    var filterButtons = Array.prototype.slice.call(root.querySelectorAll('.pt-filter-btn'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('.pt-pcard'));

    // Alternate the image side on the cards that are currently visible,
    // so filtering never leaves two same-sided cards next to each other.
    function applyLayout() {
      var visibleIndex = 0;
      cards.forEach(function (card) {
        if (card.classList.contains('hidden')) return;
        card.classList.toggle('pt-pcard--flip', visibleIndex % 2 === 1);
        visibleIndex += 1;
      });
    }

    filterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var filter = button.getAttribute('data-filter');
        filterButtons.forEach(function (other) {
          var isActive = other === button;
          other.classList.toggle('active', isActive);
          other.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
        cards.forEach(function (card) {
          var show = filter === 'all' || card.getAttribute('data-category') === filter;
          card.classList.toggle('hidden', !show);
        });
        applyLayout();
      });
    });

    applyLayout();

    var scrollButton = root.querySelector('.pt-scroll-top');
    if (scrollButton) {
      window.addEventListener('scroll', function () {
        scrollButton.classList.toggle('visible', window.scrollY > 400);
      }, { passive: true });
      scrollButton.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
